import { useState } from 'react'

const AuthMobileRegister = () =>{

	const [value, setValue ] = useState(
	{
		nombre:"",
		apellido:"",
		email:"",
		contrasenia:"",
		contraseniaRepeat:"",
		dni:"",
		celular:"",
		check1:false,
		check2:false,
		check3:false
	}
		)

	const handleChangeForm = (e) => {
		setValue((state) => ({
	      ...state,
	      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
	    }))
	}

	const submit = async(event) =>{
		event.preventDefault();
		var modaLoading = 
		  window.Swal.fire({
		    imageUrl: window.path_service+'/images/loading.png',
		    title: 'Cargando datos...',
		    showConfirmButton: false,
		    customClass: 'ms-loading-modal',
		      allowOutsideClick: false
		  });
		  			
			if ( ["",undefined,"undefined"].includes(window.getCookie("commerce_lead_token")) ) {

			    const dataq = new FormData();
				const datavalue = Array.from(new FormData(event.target))
				//console.log(Object.fromEntries(datav));
			    for(let [key, val] of datavalue) {
			    	dataq.append(key, val );
			    }		    
				const response = await fetch(window.path_service+"/api/register",{method:'POST',body:  dataq })
				const data = await response.json()

				if ( data.hasOwnProperty("status") && data.status ) {
			        document.cookie='commerce_lead_token='+data.lead_token;

			    	if ( typeof fbq !== "undefined" ) { 
						//fbq('track', 'CompleteRegistration');
//						console.log(fbq)
			    	}

			        window.Swal.fire({
			            icon: 'success',
			            title: data.message,
			            showConfirmButton: false,
			            timer: 2500
			          });         					
					//window.location.href = "/confirmacion?process=finish&checkout=simple&orden="+id_orden;
					window.location.href = window.path_service+"/app-callback/?code="+data.code;
					modaLoading.close();
				}else{
				  	window.Swal.fire({
				          icon: 'error',
				          title: data.message,
				          showConfirmButton: false,
				          timer: 3500
				    }); 
				    modaLoading.close();					
				}
				

			}			
		
	}	

	return (

            <form method="POST" className="js-form-register" onSubmit={submit}>
               <div className="field">
                  <input id="first_name" name="nombre" placeholder="Nombre" required type="text" value = {value.nombre} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input id="last_name" name="apellido" placeholder="Apellidos" required type="text" value = {value.apellido} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input id="email" name="email" placeholder="Correo" required type="email" value = {value.email} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input id="passwd" name="contrasenia" placeholder="Contraseña" required type="password" value = {value.contrasenia} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input id="passwd2" name="contraseniaRepeat" placeholder="Repetir Contraseña" required type="password" value = {value.contraseniaRepeat} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input className="input_num" id="phone" name="celular" placeholder="Teléfono (cel)" required type="text" value = {value.celular} onChange = {handleChangeForm} /> 
               </div>
               <div className="field">
                  <input className="input_num" id="dni" name="dni" placeholder="DNI" required type="text" value = {value.dni} onChange = {handleChangeForm} /> 
               </div>
               <div className="field two">
                  <input id="terms_and_conditions" name="terms_and_conditions" required type="checkbox" value="y" />
                  <label htmlFor="terms_and_conditions">Acepto los términos y condiciones y la política de privacidad y tratamiento de datos personales</label>
               </div>
               <button className="btn" type="submit"><img className="arrow_form" src=" data:image/png;base64,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"/></button>
            </form>
	)
}

export default AuthMobileRegister;